import type {Recipe} from './types';

export const trotaPatateForno: Recipe = {
    id: 23,
    key: "trotaPatateForno",
    pictures: [
        {index: 0, url: "https://www.italiancook.it/wp-content/uploads/2017/02/IMG_1610-1-600x400.jpg"},
    ],
    i18n: {
        IT: {
            title: "Trota al forno con patate",
            servings: "Porzioni per 2 persone",
            ingredients: [
                "Patate",
                "Sale",
                "Olio di semi di arachidi",
                "Rosmarino",
                "Olio di oliva",
                "Prezzemolo tritato",
                "Aglio",
                "Trote",
            ],
            steps: [
                "Tagliare le patate a cubetti.",
                "Sciacquare in acqua più volte fino a quando l'acqua non è limpida.",
                "Lasciare a bagno per 20 minuti o più con un cucchiaio di sale per perdere l'amido.",
                "Disporre le patate in una teglia e cospargere con olio di semi di arachidi, sale e rosmarino.",
                "Cuocere le patate in forno ventilato a 200 gradi fino a prima doratura.",
                "Nel frattempo preparare un misto di olio di oliva, prezzemolo tritato e aglio.",
                "Lavare le trote e asciugarle.",
                "Cospargere le trote con il miscuglio di olio, prezzemolo e aglio sia dentro che fuori.",
                "Mettere le trote nel forno sopra le patate e passare alla modalità statica.",
                "Cuocere le trote con le patate per 25 minuti.",
            ],
            notes: "Non infornare le trote troppo tardi o le patate si bruceranno non esagerare con olio e aglio altrimenti le trote sarenno pesanti da digerire",
        },
        EN: {
            title: "Baked Trout with Potatoes",
            servings: "Serves 2",
            ingredients: [
                "Potatoes",
                "Salt",
                "Peanut oil",
                "Rosemary",
                "Olive oil",
                "Chopped parsley",
                "Garlic",
                "Trout",
            ],
            steps: [
                "Cut the potatoes into cubes.",
                "Rinse them in water multiple times until the water runs clear.",
                "Soak the potatoes for 20 minutes or more with a tablespoon of salt to reduce the starch.",
                "Place the potatoes in a baking dish and drizzle with peanut oil, salt, and rosemary.",
                "Bake the potatoes in a fan oven at 200 degrees Celsius until they start to turn golden.",
                "Meanwhile, prepare a mixture of olive oil, chopped parsley, and garlic.",
                "Wash and dry the trout.",
                "Coat the trout with the olive oil, parsley, and garlic mixture both inside and out.",
                "Place the trout in the oven on top of the potatoes and switch to static mode.",
                "Bake the trout with the potatoes for 25 minutes.",
            ],
            notes: "Do not bake the trout too late, or the potatoes will burn. Don't overdo it with oil and garlic, otherwise the trout will be hard to digest.",
        },
        PL: {
            title: "Pstrąg pieczony z ziemniakami",
            servings: "Porcje dla 2 osób",
            ingredients: [
                "Ziemniaki",
                "Sól",
                "Olej arachidowy",
                "Rozmaryn",
                "Oliwa z oliwek",
                "Posiekana pietruszka",
                "Czosnek",
                "Pstrągi",
            ],
            steps: [
                "Pokrój ziemniaki w kostkę.",
                "Opłucz je w wodzie kilkakrotnie, aż woda będzie czysta.",
                "Namocz ziemniaki przez 20 minut lub więcej z łyżką soli, aby zmniejszyć zawartość skrobi.",
                "Umieść ziemniaki w naczyniu do pieczenia i skrop olejem arachidowym, solą i rozmarynem.",
                "Piecz ziemniaki w piekarniku z termoobiegiem w temperaturze 200 stopni Celsjusza, aż zaczną się rumienić.",
                "W międzyczasie przygotuj mieszankę oliwy z oliwek, posiekanej pietruszki i czosnku.",
                "Umyj i osusz pstrągi.",
                "Posmaruj pstrągi mieszanką oliwy, pietruszki i czosnku, zarówno w środku, jak i na zewnątrz.",
                "Umieść pstrągi w piekarniku na ziemniakach i przełącz na tryb statyczny.",
                "Piecz pstrągi z ziemniakami przez 25 minut.",
            ],
            notes: "Nie piecz pstrągów zbyt późno, bo ziemniaki się spalą. Nie przesadzaj z olejem i czosnkiem, bo inaczej pstrągi będą ciężkie do strawienia.",
        },
    },
};
